module.exports = __webpack_public_path__ + "img/charts-pie-and-bars-dark.41fdc167.svg";